// extracted by mini-css-extract-plugin
export default {"mainContainer":"BasicProgressStats_mainContainer__G4Onc","dashboardProgressText":"BasicProgressStats_dashboardProgressText__KFEPv"};